// extracted by mini-css-extract-plugin
module.exports = {"searchResultsTitle":"articles_searchResultsTitle__VNEQ9","emptyState":"articles_emptyState__AxKCn","pagination":"articles_pagination__x4XZF"};